import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { editView } from "../../../store/views/actions";
import { getViews } from "../../../store/views/selectors";
import { generateWidgetTransactionWithAI, handleSecSnackBar, invokeGetService, invokePostService, setDashboardRefresh, setReRender, toggleRightDrawer } from "../../../store/global/actions";
import { findSelectedSchema } from "../../../services/builder/util";
import DataValidator from '../../../services/dataValidator';
import ErrorPresenter from '../../atoms/errors/ErrorPresenter';
import { getDetailsFromUrl } from '../../../services/blueprint'
import { getAIWidgetTransactionDetails, getRenderCount, getReRender, getRightDrawerStatus } from '../../../store/global/selectors';
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import JsonTableEditor from '../../atoms/jsonFormEditor/JsonTableEditor.js';
import { Grid } from '@material-ui/core';
import UpdateCancel from '../../atoms/buttons/UpdateCancel.js';
import { customizeMappingForm, getMappingSchema, getMappingSchemaData } from '../../../services/entities/DashboardBuilder.js';
import { findHelperText, injectInlineHelperText, modifyViewsSchemaWithMappedFields, updateViewSchema } from '../../../utils/DashboardBuilder.js';
import FieldMappingTree from './FieldMappingTree.js';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader.js';
import TransactionDialog from '../alerts/CreateTransactionAlert.js';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import CreateTransaction from '../transactions/CreateTransaction.js';

const options = {
    form_name_root: "datasource",
    show_errors: "interaction",
}


export default function MappingSelector({ isView = false, id, type, action, onClose, rootId, onCompletion }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const selectedView = useSelector(getViews);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);

    const [clusterlets, setClusterlets] = useState([]);
    const [events, setEvents] = useState([]);
    const [fieldList, setFieldList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [messages, setMessages] = useState([]);
    const [payloadData, setpayloadData] = useState({});
    const [loading, setLoading] = useState(true)
    const [schemaValues, setSchemaValues] = useState({})
    const [isUpdating, setIsUpdating] = useState(false);
    const [openFieldTree, setOpenFieldTree] = useState(false);
    const [randomNumber, setRandomNumber] = useState(null);
    const [validationErrors1, setValidationErrors1] = useState([]);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [delegates, setDelegates] = useState([]);
    const [schema, setSchema] = useState({});
    const [jsonEditor, setJsonEditor] = useState(null);
    const [createTransaction, setCreateTransaction] = useState(false);
    const [transactionDetails, setTransactionDetails] = useState(null);
    const [fetchTrasactionName , setFetchTransactionName] = useState("")


    const { slug, blueprintId } = getDetailsFromUrl();

    const selectedEntity = isView ? selectedView : findSelectedSchema({ schemas: selectedView.view_schema, id }); //In case of view root level mapping, entire view object will be given
    const aiWidgetTransactionDetails = useSelector(getAIWidgetTransactionDetails)
    const renderCount = useSelector(getReRender)
    console.log({renderCount})
    useEffect(() => {
        loadDataSourceMappingForm()
    }, [renderCount])

    useEffect(() => {
        // expose React state setter for JSON Editor DOM code
        window.__openCreateTransaction = () => {
          setCreateTransaction(true);
        };
      
        return () => {
          delete window.__openCreateTransaction;
        };
      }, []);

    useEffect(() => {
       
        if (!transactionDetails?._id) return;
    
        const txId = transactionDetails._id;
    
        const updatedSchema = getMappingSchema({
            clusterlets,
            delegates,
            events,
            transactions: [...transactions, transactionDetails],
            isView
        });

        setSchema(updatedSchema);
    
        setSchemaValues({
            transaction: {
                [txId]: txId,
                event: transactionDetails.name,
                field: selectedEntity?.name ? selectedEntity?.name : "",
                clusterlet: transactionDetails.clusterlets?.[1]?.name,
                instance: "{instance}" ,
            }
        });

    }, [transactionDetails]);

    useEffect(() => {
        const loader = document.getElementById('trigger-txn-create-loader');
        const btnsWrapper = document.getElementById('trigger-btns-wrapper');
        
        // Safety check: ensure elements exist before proceeding
        if (!loader || !btnsWrapper) return;
    
        const spans = btnsWrapper.querySelectorAll('span');
        const isLoading = aiWidgetTransactionDetails?.status === "loading" && 
                          aiWidgetTransactionDetails?.entity?.id === id;
    
        if (isLoading) {
            loader.style.display = 'inline-block';
            spans.forEach(span => {
                // 1. Remove the custom hover effects
                span.onmouseover = null;
                span.onmouseout = null;
                
                // 2. Visual Reset & "Disabled" Look
                span.style.textDecoration = 'none';
                span.style.opacity = '0.5';         // Makes them look faded
                span.style.cursor = 'not-allowed'; // Changes cursor to the "circle-slash"
                
                // 3. Prevent Clicks
                span.style.pointerEvents = 'none'; 
            });
        } else {
            loader.style.display = 'none';
            spans.forEach(span => {
                if (span.id === "trigger-create-tx-action" || span.id === "trigger-create-with-ai-tx-action") {
                    span.onmouseover = () => { span.style.textDecoration = 'underline'; };
                    span.onmouseout = () => { span.style.textDecoration = 'none'; };
                    span.style.pointerEvents = 'all'; 
                    span.style.opacity = '1'; 
                }
            });
        }
    
        // Optional: Cleanup to prevent memory leaks or odd behavior on unmount
        return () => {
            spans.forEach(span => {
                span.onmouseover = null;
                span.onmouseout = null;
            });
        };
    }, [aiWidgetTransactionDetails, id]); // Added 'id' here
    

    const loadDataSourceMappingForm = () => {
        dispatch(invokeGetService('getBlueprintConstructs', [])).then((response) => {
            if (response.status) {
                setClusterlets(response.data.clusterlets.filter(c => c.type === 2 || c.type === 3));
                setDelegates(response.data.clusterlets.filter(c => c.type === 1));
                setEvents(response.data.events);
                setFieldList(response.data.fields);
                setSectionList(response.data.sections);
                setTransactions(response.data.transactions);
                setMessages(response.data.message);
                const clusterletList = response.data.clusterlets.filter(c => c.type === 2 || c.type === 3);
                const delegateList = response.data.clusterlets.filter(c => c.type === 1);
                const formSchema = getMappingSchema({ clusterlets: clusterletList, delegates: delegateList, events: response.data.events, transactions: response.data.transactions, isView });
                setSchema(formSchema);
                setSchemaValues(getMappingSchemaData({ selectedEntity, transactions: response.data.transactions, events: response.data.events, clusterlets: response.data.clusterlets }));
                setLoading(false);
                generateViewTxName(response.data.transactions, selectedEntity?.name );
            }
        });
    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };


    const handleViewUpdate = (updatedView) => {
        dispatch(invokePostService('updateView', { view: updatedView , fetchTransaction : transactionDetails, selectedEntity }, [selectedView._id])).then(response => {
            setIsUpdating(false);
            if (response.status === true) {
                dispatch(editView(updatedView));
                dispatch(handleSecSnackBar({ open: true, message: `${type === "view" ? "View" : type === 'section' ? 'Section' : type === 'ui' ? 'Widget' : 'Field'} updated`, severity: "success" }));
                dispatch(setReRender())
            } else {
                if (response.code === 255) {
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    if (rightDrawerStatus === true) dispatch(toggleRightDrawer());
                }
            }
        })
    }

    const showCustomValidationErrors = (errors) => {
        errors.forEach(error => {
            const divPresent = document.getElementById(`validation-error-${error.path}`);
            if (!divPresent) {
                const inputWrapper = document.querySelectorAll(`[data-schemapath="${error.path}"]`)[0]
                const input = inputWrapper.querySelectorAll('.form-control')[0]
                input?.insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica;" >${error.message}</p>`);
            }
        })
    }

    const clearErrors = () => {
        const errorDivs = document.querySelectorAll('.validation-error');
        for (let i = 0; i < errorDivs.length; i++) {
            errorDivs[i].remove();
        }
    };


    const customValidation = (formData) => {

        const mappingInfo = formData?.transaction || {};
        const mapping_id = Object.keys(mappingInfo)[0];

        let errors = [];

        const isTransactionMaping = mapping_id && (transactions || [])?.some(e => e?._id?.toString() === mapping_id.toString());

        if (formData?.transaction?.instance === "" && isTransactionMaping) {
            errors.push({
                path: "datasource.transaction.instance",
                property: 'format',
                message: "Instance is required"
            });

        }
        
        return errors;
    }


    const onUpdate = () => {
        if (!jsonEditor) {
            console.error("jsonEditor is null")
            return;
        }
        const formData = jsonEditor.getEditor(`${options.form_name_root}`).getValue();
        clearErrors();
        const customErrors = customValidation(formData);
        if (customErrors.length > 0) {
            showCustomValidationErrors(customErrors);
            return;
        }
        setIsUpdating(true);
        const payload = { ...selectedEntity, mapping: {} };
        
        if (formData.transaction) {
            let transaction = Object.keys(formData.transaction)[0];
            if (transaction && transaction !== "select") {
                payload.mapping.source = "transaction";
                payload.mapping.transaction = transaction;
                if (formData.transaction.instance && formData.transaction.instance !== '') payload.mapping.instance = formData.transaction.instance;
                if (formData.transaction.field && formData.transaction.field !== '') payload.mapping.field = formData.transaction.field;
            }
        }
        
        let updatedView = {};
        if (isView) {
            updatedView = {
                ...payload
            }
        } else {
            updatedView = updateViewSchema(selectedView, 'edit', { id: payload.id, updatedData: payload });
        }
        setpayloadData(updatedView);


        if (selectedEntity.category === "section") {
            const modifiedSection = modifyViewsSchemaWithMappedFields({ schema: [payload], clusterlets, transactions, events, messages, sections: sectionList, fields: fieldList });
            dispatch(setDashboardRefresh({ type: "section", action: "edit", entity: modifiedSection[0] }));
            updatedView = updateViewSchema(selectedView, 'edit', { id: payload.id, updatedData: modifiedSection[0] });

        } else if (selectedEntity.category === "ui") {
            const modifiedWidget = modifyViewsSchemaWithMappedFields({ schema: [payload], clusterlets, transactions, events, messages, sections: sectionList, fields: fieldList });
            dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: modifiedWidget[0] }));
            updatedView = updateViewSchema(selectedView, 'edit', { id: payload.id, updatedData: modifiedWidget[0] });

        }

        // Mapping validation
        if (payload?.mapping !== undefined && payload?.mapping?.source !== undefined && payload?.mapping?.source == 'clusterlet') {
            const clusterletList = clusterlets.filter(cluster => cluster._id === payload?.mapping?.clusterlet)
            const validator = new DataValidator({ views: [updatedView], clusterlets: clusterletList, sections: sectionList, fields: fieldList })
            validator.validateViewMapping();
            const res = validator.validationErrors;
            let matchingError = res.filter(result => result.item == payload?.mapping?.field)
            if (matchingError.length > 0) {
                setIsUpdating(false);
                setValidationErrors1(matchingError);
            } else {
                handleViewUpdate(updatedView);
            }
        }
        else {
            handleViewUpdate(updatedView);
        }
    }

    const generateWidgetTransaction = () => {
        dispatch(generateWidgetTransactionWithAI({
            status: 'loading',
            entity: selectedEntity
        }))
    }

    const onChangeJsonEditor = (data, editor) => {
        const num = Math.random();
        setRandomNumber(num);
        setJsonEditor(editor);
        customizeMappingForm({ data, randomNumber: num, clusterlets, events, delegates, transactions ,setCreateTransaction, type, generateWidgetTransaction})

        let fieldTreeEventButton = document.getElementById(`field-tree-event-btn${num}`);
        if (data?.transaction && !data?.transaction?.hasOwnProperty('select')) {
            let transactionSelected = data.transaction;
            setSelectedTransaction(transactionSelected);
        } else {
            setSelectedTransaction(null);
            if (fieldTreeEventButton) {
                fieldTreeEventButton.disabled = true;
            }
        }

        const fieldTreeEventBtn = document.getElementById(`field-tree-event-btn${num}`);
        if (fieldTreeEventBtn ) {
            fieldTreeEventBtn.addEventListener('click', onClickEventFieldIcon);
        }

        // Inject the helper text in the form
        const viewElement = type !== "ui" ? type : selectedEntity?.type;
        const helperText = findHelperText("data_source_mapping", viewElement)
        injectInlineHelperText({
            formId: "data_source_form", 
            schemaPath: "datasource.transaction", 
            helperText: helperText
        })
        
    }


    function onClickEventFieldIcon() {
        setOpenFieldTree(true);
    }


    const onFieldSelection = (selectedNode) => {
        setOpenFieldTree(false);
        // For setting the field selected from tree in field input field
        if (selectedNode !== null && selectedNode?.tagLabel !== undefined) {
            if (jsonEditor) {
                let field = jsonEditor.getEditor('datasource.transaction.field');
                if(field) {
                    field.setValue(selectedNode.tagLabel);
                }
            }
            const field = document.getElementsByName('datasource[transaction][field]');
            if (field && field?.length > 0) field[0].value = selectedNode.tagLabel;
        }
    }

    const onCloseTransactionDialog = () => {
        setCreateTransaction(false)

    }

    const generateViewTxName = (transactions, viewName) => {

        if (!viewName) return;

        const normalizedViewName = viewName
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "_");

        const baseName = `fetch_${normalizedViewName}_data`;

        // Collect existing transaction names
        const existingNames = new Set(
            (transactions || []).map(tx => tx.name)
        );

        // If base name doesn't exist, use it directly
        if (!existingNames.has(baseName)) {
            setFetchTransactionName(baseName);
            return;
        }

        // Otherwise generate versioned name
        let version = 2;
        let newName = `${baseName}_v${version}`;

        while (existingNames.has(newName)) {
            version += 1;
            newName = `${baseName}_v${version}`;
        }

        setFetchTransactionName(newName);

    }

    return (

        <>
            {loading && <SkeletonLoader type='form' isLabelled />}
            {!loading && <>
                
                
                {createTransaction && <TransactionDialog onClose={onCloseTransactionDialog} forView={true} transactionDetails={transactionDetails} setTransactionDetails={setTransactionDetails} fetchTrasactionName={fetchTrasactionName}/>}

                <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId={"data_source_form"} />

                {openFieldTree && <FieldMappingTree open={openFieldTree} onCompletion={onFieldSelection} onClose={() => { setOpenFieldTree(false); }} schemaValues={schemaValues} selectedTransaction={selectedTransaction} />}

                {validationErrors1.length > 0 && <ErrorPresenter errors={validationErrors1.filter(validation => validation?.focusObject?.name == selectedEntity?.name)} closeCallback={() => handleViewUpdate(payloadData)} cancelCallback={() => setValidationErrors1([])} messageTemplate={`Digital twin '[constructName]' does not contain a field '[item]' ( view '[featureEntity]' )`} />}
            </>}
            <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginTop: '30vh' } : { display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel updateDisable={isUpdating || loading} content={isUpdating ? (action === "create" ? "Creating.." : "Updating..") : (action === "create" ? "Create" : "Update")} onUpdate={onUpdate} onCancel={onClose} />
            </Grid>
        </>
    )
} 